module.exports = __webpack_public_path__ + "img/cncb.9cc69eba.png";